// extracted by mini-css-extract-plugin
module.exports = {"risk":"styles__risk--25jCE","standard":"styles__standard--1mNal","toggle":"styles__toggle--3FYhJ","icon":"styles__icon--2x6rH"};